export default __webpack_public_path__ + "static/mhn-8c4b6ed12ba2429556851e6c8f152b4d.svg";